export default __webpack_public_path__ + "static/media/liqwid.40ff7708.svg";